import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';

import { Dashboard } from './components/Dashboard';
import { AuthRoute } from './components/PrivateRoute';
import { ProjectRequestForm } from './components/ProjectRequestForm';
import { MainProjectComponent } from './components/ProjectComponent/MainProjectComponent';
import Unauthorized from './components/Unauthorized';
import { Token } from './Token';
import SSOLogin from './components/SSOLogin';
import ProtectedLayout from './components/ProtectedLayout';
import Contact from './components/Contact';
import Profile from './components/Profile';
import TAMULogo from './img/TAMULogo.svg';
import FeedbackBanner from './components/FeedbackBanner';
import ProposalViewer from './components/ProposalComponent/ProposalViewer';
import AdminProjectProposalSummary from './components/AdminProjectProposalSummary';

function App() {
  useEffect(() => {
    const existing = document.querySelector("link[rel='icon']");
    if (existing) {
      existing.href = TAMULogo;
    } else {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = TAMULogo;
      document.head.appendChild(link);
    }
  }, []);

  return (
    <Router>
      <GlobalStyles
        styles={{
          body: { margin: 0, padding: 0, height: '100%', overflowX: 'hidden' },
          html: { margin: 0, padding: 0, height: '100%' },
        }}
      />
      <CssBaseline />
      <FeedbackBanner />

      <Routes>
        <Route path="/" element={<SSOLogin />} />
        <Route path="/login" element={<SSOLogin />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/token" element={<Token />} />
        <Route path="/contact" element={<Contact />} />

        <Route element={<AuthRoute />}>
          <Route
            path="/dashboard"
            element={
              <ProtectedLayout>
                <Dashboard />
              </ProtectedLayout>
            }
          />
          <Route
            path="/project-form"
            element={
              <ProtectedLayout>
                <ProjectRequestForm />
              </ProtectedLayout>
            }
          />
          <Route
            path="/projects"
            element={
              <ProtectedLayout>
                <MainProjectComponent />
              </ProtectedLayout>
            }
          />
          <Route
            path="/proposal-viewer/:projectID"
            element={
              <ProtectedLayout>
                <ProposalViewer />
              </ProtectedLayout>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedLayout>
                <Profile />
              </ProtectedLayout>
            }
          />
          <Route
            path="/admin/project-proposals"
            element={
              <ProtectedLayout>
                <AdminProjectProposalSummary />
              </ProtectedLayout>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;

